import { apiRoutes } from '@/config/api-routes'
import { usersApi } from '@/lib/axios'

export type ConfirmUserType = 'confirmAccount' | 'confirmCompany'

export async function confirmUser(
  confirmationToken: string,
  type: ConfirmUserType,
  signal?: AbortSignal,
) {
  return usersApi.post(
    apiRoutes[type],
    {},
    {
      params: { token: confirmationToken },
      signal,
    },
  )
}
